import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import strings from 'owa-strings/owa-common-strings';

export default function createPolicyTipsViewState(): PolicyTipsViewState {
    return {
        inProgressPolicyMatch: createPolicyMatchWrapper(),
        succeededPolicyMatch: createPolicyMatchWrapper(),
        pendingPolicyMatch: createPolicyMatchWrapper(),
        isRequestInProgress: false,
        pendingRequests: false,
        handlerDisabled: false,
        isOverridden: false,
        overrideJustification: null,
        isReportedFalsePositive: false,
        complianceUrl: '',
        blockString: strings.policyTipsBlockDefault,
        notifyString: strings.policyTipsNotifyDefault,
        overrideString: strings.policyTipsBlockDefault,
    };
}

function createPolicyMatchWrapper() {
    return {
        itemId: null,
        scanResultData: null,
        scanResultMetaData: null,
        subjectChecksum: 0,
        contentChecksum: 0,
        eventTrigger: null,
        policyMatchDetails: [],
        attachmentIds: [],
    };
}
